import React from 'react';
import { Layout, Menu } from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
} from '@ant-design/icons';

const { Header, Footer, Sider, Content } = Layout;
const { SubMenu } = Menu;

function Sidebar () {
  const [ showSider, setShowSider ] = React.useState(false);

  return (
    <Sider onCollapse={() => setShowSider(!showSider)} collapsible collapsed={showSider}>
      <div className="logo">
        <div style={{ color: 'white', fontFamily: 'Amatic SC', fontSize: '25px', padding: '10px', justifyContent: 'center' }}>Crime Around The World</div>
      </div>
      <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
        <SubMenu title="Podcasts">
        </SubMenu>
        <Menu.Item key="1" icon={<UserOutlined />}>
          Swindled
        </Menu.Item>
        <Menu.Item key="2" icon={<VideoCameraOutlined />}>
          Crime Junkie
        </Menu.Item>
        <Menu.Item key="3" icon={<UploadOutlined />}>
          RedHanded
        </Menu.Item>
      </Menu>
    </Sider>
  )
};

export default Sidebar;